import { Button, Input, message, Modal } from "antd";
import styles from "./EditItemDetails.module.css";
import { useEffect, useRef } from "react";

const ExchangeEditItemDetails = ({
  itemDetailsOpen,
  setItemDetailsOpen,
  setItemDetailsData,
  itemDetailsData,
  itemDesignCode,
  setBarCodeData,
  barCodeData,
  itemExchangeDetailsOpen,
  setItemExchangeDetailsOpen,
  setItemExchangeDetailsData,
  itemExchangeDetailsData,
  itemExchangeDesignCode,
  setExchangeData,
  exchangeData,
  qtyData,
  exchangeQtyData,
  offerARate,
  offerBRate,
  smCodeRef,
  adminType,
}) => {
  const inputRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setItemExchangeDetailsOpen(false);
    smCodeRef.current?.focus();
  };
  useEffect(() => {
    if (itemExchangeDetailsOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [itemExchangeDetailsOpen]);

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      title={
        <strong
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#114a3d",
            borderRadius: "8px",
            padding: "4px 8px",
            color: "white",
          }}
        >
          Product Details
        </strong>
      }
      open={itemExchangeDetailsOpen}
      onCancel={handelCancel}
      closable={false}
      onOk={handelCancel}
      footer={null}
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      <div className={styles.cardContainer2}>
        <div className={styles.infoBox2}>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Design Code</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "18px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                  fontWeight: "bold",
                }}
                disabled
                value={
                  //   itemDetailsData?.DesignCode ??
                  itemExchangeDetailsData?.DesignCode
                }
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Product Name</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={
                  //   itemDetailsData?.ProdName ??
                  itemExchangeDetailsData?.ProdName
                }
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Qty</span>
            <span className={styles.value2}>
              {/* {itemDetailsOpen ? (
                <Input
                  placeholder="Enter Qty"
                  ref={inputRef}
                  style={{
                    width: "200px",
                    height: 32,
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  value={itemExchangeDetailsData?.stock ?? ""}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) => {
                    const val = e.target.value;
                    const input = e.target.value;

                    // ✅ Allow only numbers with up to 2 decimals
                    if (!/^\d*\.?\d{0,2}$/.test(val)) return;
                    if (itemDetailsData?.SMODEL === "A") {
                      const qty = Number(input);
                      const maxOfferQty = 3;

                      // stop if qty exceeds max
                      if (qty > maxOfferQty) return;

                      const rate = Number(offerARate) || 0;

                      // handle qty logic
                      const finalQty = qty;
                      const oQty =
                        qty === 2
                          ? itemDetailsData?.OQTY2
                          : itemDetailsData?.OQTY3;

                      // prevent divide by zero
                      const rateValue =
                        finalQty > 0 ? (oQty || 0) / finalQty : 0;

                      const price = qty === 1 ? rate : rateValue;
                      setBarCodeData((prev) =>
                        prev.map((item, index) =>
                          index === itemDesignCode
                            ? itemDetailsData?.SMODEL === "A"
                              ? {
                                  ...item,
                                  stock: qty,
                                  CPrice: price,
                                  offer: price,
                                }
                              : { ...item, stock: val }
                            : item,
                        ),
                      );

                      if (itemDetailsData?.SMODEL === "A") {
                        setItemDetailsData((prev) => ({
                          ...prev,
                          stock: qty,
                          CPrice: price,
                          offer: price,
                        }));
                      } else {
                        setItemDetailsData((prev) => ({
                          ...prev,
                          stock: val,
                        }));
                      }
                    } else if (itemDetailsData?.SMODEL === "B") {
                      const qty = Number(input);
                      const maxQty = 3;

                      // stop if qty exceeds max
                      if (qty > maxQty) return;

                      const rate = Number(offerBRate) || 0;

                      const rateValue = Number(itemDetailsData?.CPrice) || 0;

                      // handle qty logic
                      const finalQty = qty;
                      const oQty =
                        qty === 2
                          ? itemDetailsData?.OQTY2
                          : itemDetailsData?.OQTY3;

                      const dis = finalQty > 0 ? oQty : 0;

                      const disPer = qty === 1 ? rate : dis;

                      const disAmt = (rateValue * disPer) / 100;

                      const actRate = rateValue - disAmt;

                      setBarCodeData((prev) =>
                        prev.map((item, index) =>
                          index === itemDesignCode
                            ? {
                                ...item,
                                stock: qty,
                                Disper: disPer,
                                Disamt: disAmt,
                                CPrice: rateValue,
                                offer: actRate,
                              }
                            : item,
                        ),
                      );

                      setItemDetailsData((prev) => ({
                        ...prev,
                        stock: qty,
                        Disper: disPer,
                        Disamt: disAmt,
                        CPrice: rateValue,
                        offer: actRate,
                      }));
                    } else {
                      const inputQty = val === "" ? "" : Number(val);

                      const isItem = itemDetailsOpen;

                      const designCode = isItem
                        ? itemDetailsData?.DesignCode
                        : itemExchangeDetailsData?.DesignCode;

                      if (!designCode) return;

                      // 🔢 Get max qty
                      const maxQty = isItem
                        ? (qtyData?.find((q) => q.DesignCode === designCode)
                            ?.Qty ?? 0)
                        : (exchangeQtyData?.find(
                            (q) => q.DesignCode === designCode,
                          )?.Qty ?? 0);

                      // 🔍 Calculate existing stock (exclude current edited index)
                      const currentTotal = isItem
                        ? barCodeData
                            .filter((_, index) => index !== itemDesignCode)
                            .filter((item) => item.DesignCode === designCode)
                            .reduce(
                              (sum, item) => sum + Number(item.stock || 0),
                              0,
                            )
                        : exchangeData
                            .filter(
                              (_, index) => index !== itemExchangeDesignCode,
                            )
                            .filter((item) => item.DesignCode === designCode)
                            .reduce(
                              (sum, item) => sum + Number(item.stock || 0),
                              0,
                            );

                      // ❌ Qty limit reached
                      if (Number(inputQty || 0) + currentTotal > maxQty) {
                        message.error(`Qty limit reached for ${designCode}`);
                        return;
                      }

                      // ✅ Update state
                      if (isItem) {
                        setBarCodeData((prev) =>
                          prev.map((item, index) =>
                            index === itemDesignCode
                              ? { ...item, stock: inputQty }
                              : item,
                          ),
                        );

                        setItemDetailsData((prev) => ({
                          ...prev,
                          stock: inputQty,
                        }));
                      } else {
                        setExchangeData((prev) =>
                          prev.map((item, index) =>
                            index === itemExchangeDesignCode
                              ? { ...item, stock: inputQty }
                              : item,
                          ),
                        );

                        setItemExchangeDetailsData((prev) => ({
                          ...prev,
                          stock: inputQty,
                        }));
                      }
                    }
                  }}
                  onKeyDown={(e) => handleKeyDown(e, rateRef)}
                />
              ) : ( */}
              <Input
                placeholder="Enter Qty"
                ref={inputRef}
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
                value={itemExchangeDetailsData?.stock ?? ""}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  const val = e.target.value;

                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    // const maxQty =
                    //   qtyData?.find(
                    //     (q) => q.DesignCode === itemDetailsData?.DesignCode
                    //   )?.Qty ?? 0;

                    // // 🔍 Calculate total existing stock for this DesignCode
                    // const totalExistingStock = barCodeData
                    //   .filter(
                    //     (item) =>
                    //       item.DesignCode === itemDetailsData?.DesignCode
                    //   )
                    //   .reduce((sum, item) => sum + Number(item.stock || 0), 0);

                    // // ❌ Prevent adding if it exceeds maxQty
                    // if (Number(val) + totalExistingStock > maxQty) {
                    //   message.error(
                    //     `Qty limit reached for ${itemDetailsData?.DesignCode}`
                    //   );
                    //   return;
                    // }
                    // // const maxQty = itemDetailsData?.Qty ?? 0;

                    // if (val > maxQty) return;

                    setExchangeData((prev) =>
                      prev.map((item, index) =>
                        index === itemExchangeDesignCode
                          ? { ...item, stock: val }
                          : item,
                      ),
                    );

                    setItemExchangeDetailsData((prev) => ({
                      ...prev,
                      stock: val,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  if (
                    itemDetailsData?.SMODEL === "A" ||
                    itemDetailsData?.SMODEL === "B"
                  ) {
                    handleKeyDown(e, saveRef);
                  } else {
                    handleKeyDown(e, rateRef);
                  }
                }}
              />
              {/* )} */}
            </span>
          </div>

          {/* WASTAGE */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Rate"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                ref={rateRef}
                disabled={
                  //   (itemDetailsData?.SMODEL === "A" && itemDetailsOpen) ||
                  //   (itemDetailsData?.SMODEL === "B" && itemDetailsOpen) ||
                  adminType !== "ADMIN"
                }
                value={
                  //   itemDetailsData?.CPrice ??
                  itemExchangeDetailsData?.CPrice ?? 0
                }
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const disPer =
                      //   itemDetailsData?.Disper ??
                      itemExchangeDetailsData?.Disper;
                    const rateValue = val * disPer;
                    const disAmt = rateValue / 100;
                    const ActRate = val - disAmt;
                    // if (itemDetailsOpen) {
                    //   setBarCodeData((prev) =>
                    //     prev.map((item, index) =>
                    //       index === itemDesignCode
                    //         ? {
                    //             ...item,
                    //             CPrice: val,
                    //             Disamt: disAmt,
                    //             offer: ActRate,
                    //           }
                    //         : item,
                    //     ),
                    //   );
                    //   setItemDetailsData((prev) => ({
                    //     ...prev,
                    //     CPrice: val,
                    //     Disamt: disAmt,
                    //     offer: ActRate,
                    //   }));
                    // } else {
                    setExchangeData((prev) =>
                      prev.map((item, index) =>
                        index === itemExchangeDesignCode
                          ? {
                              ...item,
                              CPrice: val,
                              Disamt: disAmt,
                              offer: ActRate,
                            }
                          : item,
                      ),
                    );
                    setItemExchangeDetailsData((prev) => ({
                      ...prev,
                      CPrice: val,
                      Disamt: disAmt,
                      offer: ActRate,
                    }));
                    // }
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disPerRef);
                }}
              />
            </span>
          </div>

          {/* DIRECTWT */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Per(%)</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Per"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled={
                  //   (itemDetailsData?.SMODEL === "A" && itemDetailsOpen) ||
                  //   (itemDetailsData?.SMODEL === "B" && itemDetailsOpen) ||
                  adminType !== "ADMIN"
                }
                ref={disPerRef}
                value={
                  //   itemDetailsData?.Disper ??
                  itemExchangeDetailsData?.Disper ?? 0
                }
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (!/^\d*\.?\d*$/.test(val)) return;
                  const updatedValue = val === 0 ? 0 : Number(val);
                  const rate =
                    // itemDetailsData?.CPrice ??
                    itemExchangeDetailsData?.CPrice;
                  const rateValue = rate * val;
                  const disAmt = rateValue / 100;
                  const ActRate = rate - disAmt;
                  //   if (itemDetailsOpen) {
                  //     setBarCodeData((prev) =>
                  //       prev.map((item, index) =>
                  //         index === itemDesignCode
                  //           ? {
                  //               ...item,
                  //               Disper: updatedValue,
                  //               Disamt: disAmt,
                  //               offer: ActRate,
                  //             }
                  //           : item,
                  //       ),
                  //     );
                  //     setItemDetailsData((prev) => ({
                  //       ...prev,
                  //       Disper: updatedValue,
                  //       Disamt: disAmt,
                  //       offer: ActRate,
                  //     }));
                  //   } else {
                  setExchangeData((prev) =>
                    prev.map((item, index) =>
                      index === itemExchangeDesignCode
                        ? {
                            ...item,
                            Disper: updatedValue,
                            Disamt: disAmt,
                            offer: ActRate,
                          }
                        : item,
                    ),
                  );
                  setItemExchangeDetailsData((prev) => ({
                    ...prev,
                    Disper: updatedValue,
                    Disamt: disAmt,
                    offer: ActRate,
                  }));
                  //   }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disAmtRef);
                }}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Amt</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Amt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled={
                  //   (itemDetailsData?.SMODEL === "A" && itemDetailsOpen) ||
                  //   (itemDetailsData?.SMODEL === "B" && itemDetailsOpen) ||
                  adminType !== "ADMIN"
                }
                ref={disAmtRef}
                value={
                  //   itemDetailsData?.Disamt ??
                  itemExchangeDetailsData?.Disamt ?? 0
                }
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const rate =
                      //   itemDetailsData?.CPrice ??
                      itemExchangeDetailsData?.CPrice;
                    const ActRate = rate - val;
                    // if (itemDetailsOpen) {
                    //   setBarCodeData((prev) =>
                    //     prev.map((item, index) =>
                    //       index === itemDesignCode
                    //         ? { ...item, Disamt: val, offer: ActRate }
                    //         : item,
                    //     ),
                    //   );
                    //   setItemDetailsData((prev) => ({
                    //     ...prev,
                    //     Disamt: val,
                    //     offer: ActRate,
                    //   }));
                    // } else {
                    setExchangeData((prev) =>
                      prev.map((item, index) =>
                        index === itemExchangeDesignCode
                          ? { ...item, Disamt: val, offer: ActRate }
                          : item,
                      ),
                    );
                    setItemExchangeDetailsData((prev) => ({
                      ...prev,
                      Disamt: val,
                      offer: ActRate,
                    }));
                  }
                  //   }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, saveRef);
                }}
              />
            </span>
          </div>

          {/* TOTALWT */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Act Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={
                  //   itemDetailsOpen
                  //     ? Number(itemDetailsData?.offer)?.toFixed(2)
                  //     :
                  Number(itemExchangeDetailsData?.offer)?.toFixed(2)
                }
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Amount</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={
                  //   itemDetailsOpen
                  //     ? Number(
                  //         itemDetailsData?.stock * itemDetailsData?.offer,
                  //       )?.toFixed(2)
                  //     :
                  Number(
                    itemExchangeDetailsData?.stock *
                      itemExchangeDetailsData?.offer,
                  )?.toFixed(2)
                }
              />
            </span>
          </div>
        </div>
      </div>
      <div
        style={{
          textAlign: "right",
          marginTop: 10,
          display: "flex",
          justifyContent: "right",
          gap: "10px",
        }}
      >
        {/* <Button
          onClick={() => {
            handelCancel();
          }}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #BF092F",
            color: "#BF092F",
            borderRadius: "8px",
            width: 100,
          }}
        >
          Cancel
        </Button> */}
        <Button
          type="primary"
          ref={saveRef}
          onClick={() => {
            handelCancel();
          }}
          style={{
            width: 100,
            backgroundColor: "#006400",
            borderRadius: "8px",
          }}
        >
          Save
        </Button>
      </div>
      {/* {itemDetailsData?.SMODEL === "A" ? (
        <div
          style={{
            textAlign: "center",
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "8px",
            background: "#003161",
            padding: "5px",
            color: "#fff",
            gap: "2px",
          }}
        >
          <span>BUY QTY : 1 @ {offerARate}/-</span>
          <span>BUY QTY : 2 @ {itemDetailsData?.OQTY2}/-</span>
          <span>BUY QTY : 3 @ {itemDetailsData?.OQTY3}/-</span>
        </div>
      ) : itemDetailsData?.SMODEL === "B" ? (
        <div
          style={{
            textAlign: "center",
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "8px",
            background: "#003161",
            padding: "5px",
            color: "#fff",
            gap: "2px",
          }}
        >
          <span>BUY QTY : 1 @ {offerBRate}%</span>
          <span>BUY QTY : 2 @ {itemDetailsData?.OQTY2}%</span>
          <span>BUY QTY : 3 @ {itemDetailsData?.OQTY3}%</span>
        </div>
      ) : (
        ""
      )} */}
    </Modal>
  );
};
export default ExchangeEditItemDetails;
